import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from 'react';
import classNames from 'classnames';
import { CheckboxIcon } from '../../icons/checkbox';
import * as styles from './styles.css';
export var CheckboxView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxView, _React$Component);

  function CheckboxView() {
    _classCallCheck(this, CheckboxView);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxView).apply(this, arguments));
  }

  _createClass(CheckboxView, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var mediaType = props.mediaType;
      return React.createElement("span", {
        className: classNames(props.className, styles.checkbox, styles.common, props.checked && styles.checked, props.disabled && styles.disabled, mediaType && styles["mediaType--".concat(mediaType)])
      }, React.createElement("span", {
        className: styles.box
      }, React.createElement(CheckboxIcon, {
        __classNames: styles.icon,
        custom: {
          size: '84%'
        }
      })), props.label && React.createElement("span", {
        className: styles.label
      }, props.label));
    }
  }]);

  return CheckboxView;
}(React.Component);